<template>
  <div class="home_content">
    <Layout class="home_box">
      <Sider class="home_left" hide-trigger width="120" :style="{backgroundColor: leftbg}">
        <div class="themecolor">
          <span>主题颜色</span>
          <ul>
            <li v-for="(item, index) in themecolors" :key="index" :style="{backgroundColor: item}" @click="themeColorClick(item)"></li>
          </ul>
        </div>
        <div class="nav_list_content">
          <ul>
            <li v-for="(item, index) in navlist" :key="index" :style="{backgroundColor: navsign == index ? '#fff' : ''}" @click="navClick(item, index)">
              <Badge :count="!$store.state.openmall ? shoppingcarnum : 0" v-if="item.id == 1">
                <i class="icon iconfont" :class="item.icon" :style="{color: navsign == index ? leftbg : ''}"></i>
              </Badge>
              <i v-else class="icon iconfont" :class="item.icon" :style="{color: navsign == index ? leftbg : ''}"></i> 
              <span :style="{color: navsign == index ? leftbg : ''}">{{item.name}}</span>
            </li>
          </ul>
        </div>
      </Sider>
      <Layout>
        <Header class="home_head_content">
          <div class="home_head_box">
            <div class="home_head_left">
              <h1>
                <router-link to="/"><img class="logo" :src="headlogo" /></router-link>
              </h1>
            </div>
            <div class="home_head_right">
              <div class="home_head_fun_content">
                <div class="home_head_fun" @click="goNotice">
                  <i class="icon iconfont icon-cheng2"></i>
                  <Badge :count="headnews">消息通知</Badge>
                </div>
              </div>
              <div class="home_head_fun_content">
                <div class="home_head_fun">
                  <i class="icon iconfont icon-cheng"></i>
                  <span>帮助</span>
                  <i class="icon iconfont icon-icon_zhankai_xiangxia"></i>
                </div>
                <div class="home_head_link">
                  <ul>
                    <li>
                      <router-link to="/Help">帮助中心</router-link>
                    </li>
                    <li>
                      <router-link to="/ContactService">联系客服</router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="home_head_fun_content" v-if="!this.$store.state.openmall">
                <div class="home_head_fun">
                  <i class="icon iconfont icon-cheng1"></i>
                  <span>{{name}}</span>
                  <i class="icon iconfont icon-icon_zhankai_xiangxia"></i>
                </div>
                <div class="home_head_link">
                  <ul>
                    <li>
                      <router-link to="/Accounts">会员中心</router-link>
                    </li>
                    <li>
                      <a href="javascript:;" @click="supplierClick">切换供货商</a>
                    </li>
                    <li>
                      <a href="javascript:;" @click="signout">退出</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="home_head_fun_content" v-else>
                <div class="home_head_fun">
                  <span @click="gotologin">登录</span>
                </div>
              </div>
            </div>
          </div>
        </Header>
        <div class="crumbs_content">
          <div class="crumbs_left">
            <div v-if="navsign != -1">
              <Breadcrumb separator=">" class="crumbs">
                <BreadcrumbItem
                  :to="item.path"
                  v-for="(item, index) in routerlist"
                  :key="index">
                  {{item.name}}</BreadcrumbItem>
              </Breadcrumb>
              <div class="crumbs_notice_content">
                <i class="icon iconfont icon-tongzhi"></i>
                <span>全场商品</span>
                <div class="crumbs_notice_list">
                  <marquee behavior="behavior" loop="2" width="248">
                    <ul>
                      <li v-for="(item, index) in notice" :key="index">{{item}}</li>
                    </ul>
                  </marquee>
                </div>
              </div>
            </div>
            <div v-else>
              <h2>欢迎登录</h2>
              <small v-if="logintime != ''">上次登录时间：{{logintime}}</small>
            </div>
          </div>
          <div class="crumbs_right">
            <Input v-model="headsearchinput" style="width: 310px" search @on-search="searchclick">
              <Select v-model="headsearchselect" slot="prepend" style="width: 100px">
                <Option value="order">搜订货单</Option>
                <Option value="returnorder">搜退货单</Option>
                <Option value="goods">搜商品</Option>
              </Select>
            </Input>
          </div>
        </div>
        <Content class="home_main">
          <router-view :searchsign="headsearchselect" :searchname="searchname" />
        </Content>
      </Layout>
    </Layout>
    <!-- 切换为供货商弹窗 -->
    <Modal
      class="agreement_content"
      v-model="suppliermodal"
      :width="560"
      :scrollable="false"
    >
        <div slot="header" class="model_head">
          <span>切换为供货商</span>
        </div>
        <div class="model_body">
          <div class="suppliermodal_content">
            <Form :label-width="60">
              <FormItem label="输入密码">
                  <Input type="password" v-model="supplierpwd" placeholder="请输入供货平台密码"></Input>
              </FormItem>
            </Form>
          </div>
        </div>
        <div slot="footer">
          <Button type="warning" @click="supplierOk">提交</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import api from '@/request/api.js'
export default {
  name: 'index',
  data() {
    return {
      backstage: 0, // 1 后台会员 0非后台会员
      headlogo: '', // 顶部logo
      headnews: 0, // 顶部消息通知
      name: '', // 用户名称
      headcompany: '', // 顶部公司
      logintime: '', // 上次登录时间
      themecolors: ["#5B5FC2", "#FF8000", "#01cd88", "#2d8cf0", "#ed4014"], // 主题色
      leftbg: '', // 主题色选中
      navsign: -1, // 当前选中导航
      navlist: [ // 左侧导航
          {
              id: 0, // id
              icon: "icon-shangpinfuzhi1", // 图标类名
              name: "商品", // 导航名称
              link: "/Goods/0", // 导航链接
          },
          {
              id: 1, // id
              icon: "icon-gouwuche-fuzhi", // 图标类名
              name: "购物车", // 导航名称
              link: "/ShoppingCart", // 导航链接
          },
          {
              id: 2, // id
              icon: "icon-dingdanfuzhi", // 图标类名
              name: "订单", // 导航名称
              link: "/Order", // 导航链接
          },
          {
              id: 3, // id
              icon: "icon-cuxiaofuzhi", // 图标类名
              name: "促销", // 导航名称
              link: "/Promotion", // 导航链接
          },
          {
              id: 4, // id
              icon: "icon-piaofangfuzhi", // 图标类名
              name: "优惠券", // 导航名称
              link: "/Cpupon", // 导航链接
          },
          {
              id: 5, // id
              icon: "icon-zijinfuzhi", // 图标类名
              name: "资金", // 导航名称
              link: "/PayRecordCapital", // 导航链接
          },
          {
              id: 6, // id
              icon: "icon-reportfuzhi", // 图标类名
              name: "统计", // 导航名称
              link: "/OrderGoodSummary", // 导航链接
          }
      ],
      shoppingcarnum: 0, // 购物车数量
      routerlist: null, // 面包屑
      notice: [], // 通知
      headsearchinput: '', // 头部右侧搜索input内容
      headsearchselect: 'order', // 头部右侧搜索select选中内容
      suppliermodal: false, // 切换供货商弹窗是否显示
      supplierpwd: '', // 切换供货商密码
      searchname: '', // 顶部搜索内容
    }
  },
  methods: {
    getInfo () { // 获取数据
      this.http.post(api.frame)
      .then(response => {
        console.log(response.data.msg)
        document.title = response.data.msg.baseinfo.orderingname + '-' + response.data.msg.baseinfo.slogan
        this.headlogo = response.data.msg.baseinfo.orderinglogo
        this.headnews = response.data.msg.baseinfo.helpnum
        this.headcompany = response.data.msg.baseinfo.orderingname
        this.name = response.data.msg.baseinfo.name
        this.logintime = response.data.msg.baseinfo.logintime
        this.notice = response.data.msg.baseinfo.cxinfo
        if (response.data.msg.baseinfo.backstage == 1) {
          this.$store.state.openmall = true
        }
        this.backstage = response.data.msg.baseinfo.backstage
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = response.data.msg.baseinfo.managelogo;
        document.getElementsByTagName('head')[0].appendChild(link);
      })
      .catch(error => {
        this.noLogin(error)
      })
    },
    supplierClick () { // 切换供货商弹窗
      this.suppliermodal = true
    },
    supplierOk () { // 确认切换供货商
      this.http.post(api.switchsupplier, {'user_pwd': this.supplierpwd})
      .then(response => {
        window.open(response.data.msg.siteurl + '/index.php?c=login&act=switchshop&client=weixin&username=' + response.data.msg.memberinfo.username + '&password=' + this.supplierpwd)
        this.supplierpwd = ''
        this.suppliermodal = false
      })
      .catch(error => {
        this.noLogin(error)
      })
    },
    signout () { // 退出登录
      localStorage.removeItem("Flag")
      document.cookie = "cook_cus_uid="
      document.cookie = "cook_cus_pwd="
      // 退出登录提示
      this.$Message.success('退出登录!')
      // 退出登录成功后跳转到指定页面
      this.$router.push("/Login")
    },
    gotologin () {
      this.$store.dispatch('openmallFun', true)
      this.$store.dispatch('requireAuthFun', false)
      document.cookie = "cook_cus_uid="
      document.cookie = "cook_cus_pwd="
      // 退出登录成功后跳转到指定页面
      this.$router.push("/Login")
    },
    themeColorClick(color) { // 修改主题色
      this.$store.dispatch('themecolorFun', color)
    },
    navClick(item, index) { // 左侧导航
      this.$router.push({
        path: item.link
      })
    },
    getBreadcrumb () { // 面包屑
      var breadNumber = this.$route.query.breadNum || 1; //url变量breadNum记录层级，默认为1，如果大于1，要添加上变量；
      var breadLength = this.$store.state.breadListState.length; //目前breadlist集合数组个数
      var curName = this.$route.name;
      var curPath = this.$route.fullPath;
      var newBread = { name: curName, path: curPath };
      var ishome = curName == "首页";
      // console.log(ishome);
      if (breadNumber === 1) {
          //点击一级菜单
          this.$store.commit("breadListStateRemove", 1); //初始化，只有首页面包屑按钮
          if (!ishome) { //如果不是首页
            this.$store.commit("breadListStateAdd", newBread); //当前页面添加到breadlist集合
          } else {
            for (var i = 0; i < this.navlist.length; i++) {
              this.navlist[i].check = false
            }
          }
      } else if (breadLength <= breadNumber) {
          //如果不是一级导航，并且breadlist集合个数等于或者小于目前层级
          this.$store.commit("breadListStateAdd", newBread); //要把当前路由添加到breadlist集合
      } else {
          this.$store.commit("breadListStateRemove", parseInt(breadNumber) + 1); //如果往回点面包屑导航，截取；
      }
      this.routerlist = this.$store.state.breadListState;
      // console.log(this.routerlist);
    },
    goNotice () { // 跳转消息通知
      this.$router.push('/Notice')
    },
    searchclick (value) { // 搜索跳转
      this.searchname = value
      if (this.headsearchselect == 'order') {
        this.$router.push('/Order')
      } else if (this.headsearchselect == 'returnorder') {
        this.$router.push('/OrderReturn')
      } else if (this.headsearchselect == 'goods') {
        this.$router.push({
          name: '商品',
          params: {
            type: 0,
          }
        })
      }
    },
    updatedrouter () { // 当前选中导航
      let nav = ''
      let sign = -1
      if (this.$route.name === '首页') {
        sign = -1
      } else if (this.$route.name == '商品' || this.$route.name == '商品详情') {
        sign = 0
      } else if (this.$route.name == '购物车' || this.$route.name == '填写订单') {
        sign = 1
      } else if (this.$route.name == '订货单' || this.$route.name == '订货详情' || this.$route.name == '出库/发货/物流' || this.$route.name == '付款记录' || this.$route.name == '退货单' || this.$route.name == '申请退货' || this.$route.name == '退货单订单详情') {
        sign = 2
      } else if (this.$route.name == '商品促销' || this.$route.name == '满减满送') {
        sign = 3
      } else if (this.$route.name == '优惠券') {
        sign = 4
      } else if (this.$route.name == '支付记录' || this.$route.name == '预存款收支明细') {
        sign = 5
      } else if (this.$route.name == '订货汇总' || this.$route.name == '订单统计' || this.$route.name == '分类统计' || this.$route.name == '品牌统计') {
        sign = 6
      } else {
        sign = 7
      }
      this.navsign = sign
    }
  },
  watch: {
    $route (newVal, oldVal) {
      this.getBreadcrumb()
    },
    '$store.state.shopcartlist' () {
      this.shoppingcarnum = this.$store.state.shopcartlist.length
    },
    '$store.state.themecolor' () {
      this.leftbg = this.$store.state.themecolor
    }
  },
  created () {
    this.getBreadcrumb()
    this.getInfo()
    this.shoppingcarnum = this.$store.state.shopcartlist.length
    this.navsign = this.$store.state.navactive
    this.leftbg = this.$store.state.themecolor
  },
  updated () {
    this.updatedrouter()
  }
}
</script>

<style scoped>
.home_content {
  height: 100vh;
  position: relative;
  background-color: #f9f9fd;
}

.home_box {
  height: 100vh;
}

.home_left {
  position: relative;
}

.themecolor {
  height: 80px;
  padding: 17px 14px 0;
  font-size: 0;
}

.themecolor > span {
  font-size: 12px;
  color: #fff;
}

.themecolor > ul {
  padding-top: 6px;
  text-align: center;
}

.themecolor > ul > li {
  width: 14px;
  height: 14px;
  margin-right: 5px;
  display: inline-block;
  border: 1px solid #fff;
  border-radius: 50%;
  cursor: pointer;
}

.themecolor > ul > li:last-child {
  margin-right: 0;
}

.nav_list_content {
  height: calc(100% - 80px);
  overflow: auto;
}

.nav_list_content > ul > li {
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  cursor: pointer;
}

.nav_list_content > ul > li i {
  font-size: 36px;
  color: #fff;
  transition: all 0.2s;
}

.nav_list_content > ul > li > span {
  font-size: 16px;
  color: #fff;
  transition: all 0.2s;
}

.home_head_content {
  width: calc(100% - 120px);
  height: 60px;
  padding: 0;
  background-color: #fff;
  position: fixed;
  z-index: 1000;
}

.home_head_box {
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
}

.home_head_left h1,
.home_head_left img {
  height: 40px;
  display: block;
}

.home_head_right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.home_head_fun_content {
  margin-left: 38px;
  position: relative;
}

.home_head_fun_content:hover .home_head_link {
  display: block;
}

.home_head_link {
  min-width: 118px;
  display: none;
  background-color: #fff;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.05);
  transform: translateX(-50%);
  position: absolute;
  top: 60px;
  left: 50%;
  z-index: 1;
}

.home_head_link > ul > li {
  line-height: initial;
  padding: 0 0 18px 0;
  text-align: center;
  font-size: 16px;
}

.home_head_link > ul > li > a {
  color: #666;
  transition: all 0.2s;
}

.home_head_link > ul > li:hover > a {
  color: #ff8000;
}

.home_head_fun {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.home_head_fun > i {
  margin-right: 8px;
  font-size: 22px;
  color: #ff8000;
  transition: all 0.2s;
}

.home_head_fun > i.icon-icon_zhankai_xiangxia {
  margin-left: 6px;
  margin-right: 0;
  font-size: 16px;
  color: #ccc;
}

.home_head_fun > span {
  font-size: 16px;
  color: #666;
}

.home_head_fun_content:hover .home_head_fun > i.icon-icon_zhankai_xiangxia {
  transform: rotate(180deg);
}

.crumbs_content {
  margin: 90px 30px 0 54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.crumbs {
  margin-right: 10px;
  display: inline-block;
}

.crumbs_left h2 {
  margin-right: 10px;
  font-size: 24px;
  color: #0c1f6d;
  display: inline-block;
  font-weight: normal;
}

.crumbs_left small {
  font-size: 14px;
  color: #999;
}

.crumbs_notice_content {
  margin-left: 32px;
  display: inline-block;
}

.crumbs_notice_content > i {
  margin-right: 6px;
  color: #666;
  vertical-align: -1px;
}

.crumbs_notice_content > span {
  font-size: 14px;
  color: #666;
}

.crumbs_notice_list {
  width: 200px;
  height: 16px;
  display: inline-block;
  overflow: hidden;
}

.crumbs_notice_list ul {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.crumbs_notice_list ul > li {
  padding: 0 6px;
  font-size: 14px;
  color: #ff8000;
  position: relative;
}

.crumbs_notice_list ul > li::before {
  content: '';
  width: 4px;
  height: 4px;
  margin-top: -3px;
  background-color: #FF8000;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 50%;
  z-index: 1;
}

.home_main {
  margin: 26px 30px 30px;
  background-color: #fff;
  border-radius: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/index.vue